'use client'
import React from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useRouter } from 'next/navigation'
import Link from 'next/link'

function ClientsPartnersSection() {
   const router = useRouter()

   // Function to handle client logo click
   const handleClientClick = (path) => {
      if (path) {
         router.push(path)
      }
   }

   return (
      <section className="section_secondary_bg">
         <div className="container">
            <div className="mb-5">
               <h2 className="tech_title section_heading_title mb-3">
                  Working With the Best Clients and Partners
               </h2>
               <div className="">
                  <p className="section_desc partners-desc">
                     From an early stage start-up's growth strategies to helping
                     existing businesses, we have done it all! The results speak
                     for themselves. Our services work.
                  </p>
               </div>
            </div>

            <Swiper
               modules={[Navigation, Pagination, Autoplay]}
               autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
               }}
               slidesPerView={1}
               grabCursor={true}
               spaceBetween={30}
               freeMode={false}
               loop={true}
               keyboard={{ enabled: true }}
               speed={600}
               navigation={{
                  nextEl: '.custom-clients-wrap-next-btn',
                  prevEl: '.custom-clients-wrap-prev-btn',
               }}
               breakpoints={{
                  768: {
                     slidesPerView: 2,
                     spaceBetween: 30,
                  },
                  992: {
                     slidesPerView: 2,
                     spaceBetween: -50,
                  },
                  1200: {
                     slidesPerView: 3,
                     spaceBetween: 85,
                  },
                  1440: {
                     slidesPerView: 4,
                     spaceBetween: 20,
                  },
               }}
               className="custom-clients_slider"
            >
               <SwiperSlide>
                  <Link
                     href={'/portfolio/magic-shoes'}
                     className="clients-logo-wrap"
                     style={{ cursor: 'pointer' }}
                  >
                     <img
                        src="/assets/svg/home/magic-shoes.svg"
                        alt="magic-shoes"
                     />
                  </Link>
               </SwiperSlide>
               <SwiperSlide>
                  <Link
                     href={'/portfolio/case-studies/robotmaker-ai'}
                     className="clients-logo-wrap"
                     style={{ cursor: 'pointer' }}
                  >
                     <img
                        src="/assets/svg/home/robot-maker.svg"
                        alt="robot-maker"
                     />
                  </Link>
               </SwiperSlide>
               <SwiperSlide>
                  <div className="clients-logo-wrap">
                     <img src="/assets/svg/home/eg.svg" alt="eg" />
                  </div>
               </SwiperSlide>
               <SwiperSlide>
                  <Link
                     href={'/portfolio/case-studies/care-boarding'}
                     className="clients-logo-wrap"
                     style={{ cursor: 'pointer' }}
                  >
                     <img
                        src="/assets/svg/home/care-boarding.svg"
                        alt="care-boarding"
                     />
                  </Link>
               </SwiperSlide>

               <div className="d-flex justify-content-center mt-4">
                  <button className="custom-clients-wrap-prev-btn">
                     <img
                        src="/assets/svg/technologies/down-arrow.svg"
                        alt="prev"
                     />
                  </button>

                  <button className="custom-clients-wrap-next-btn">
                     <img
                        src="/assets/svg/technologies/down-arrow.svg"
                        alt="next"
                     />
                  </button>
               </div>
            </Swiper>

            {/*  */}
         </div>
      </section>
   )
}

export default ClientsPartnersSection
